export default __webpack_public_path__ + "static/equilibre_illustration_laptop-ec3054bd6e1cf1fa56205d2e527b56c7.png";